import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private readonly resourceUrl = '/currency-stripe';

  constructor(private apiService: ApiService) {}

  public getCurrencies(): Observable<any> {
    return this.apiService.get(this.resourceUrl + '/currencies');
  }
}
